import { PartnerOffer } from "@/features/partnerOffers/model";
import { ref } from "vue";
import { getOffer, logInteraction } from "./api";
import { InteractionType } from "@/features/analytics/api";

export const displayedModalOffer = ref<PartnerOffer|null>();
export const displayedModalContext = ref<string|null>();

export const displayModalOffer = (context: string, offer: PartnerOffer) => {
    displayedModalContext.value = context;
    displayedModalOffer.value = offer;

    // Update URL query params, so if the user shares a link while this modal is open, we can restore it
    const url = new URL(window.location.toString());
    url.searchParams.set('offer', offer.id);
    url.searchParams.set('context', context);

    window.history.replaceState({}, '', url);
};

export const hideModalOffer = () => {
    displayedModalContext.value = null;
    displayedModalOffer.value = null;

    // Update URL query params, so if the user shares a link while this modal is open, we can restore it
    const url = new URL(window.location.toString());
    url.searchParams.delete('offer');
    url.searchParams.delete('context');

    window.history.replaceState({}, '', url);
}

export const restoreModalOfferFromQueryParams = () => {
    const url = new URL(window.location.toString());
    if (url.searchParams.has('offer') && url.searchParams.has('context')) {
        const offerId = url.searchParams.get('offer')!;
        const context = url.searchParams.get('context')!;
        
        console.log("Restoring offer from query params", offerId);

        getOffer(offerId)
        .then(offer => {
            // Avoids race condition where user loads a page with an offer to restore, but then clicks another offer on the page themselves before it loads
            if (displayedModalOffer.value) return;

            logInteraction(context, offer, InteractionType.CLICK, "directUrl");
            displayModalOffer(context, offer);
        })
        .catch(err => {
            console.error("Failed to restore offer from query params", err);
        })
    }
}